import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { StorageUtility } from "@/lib/storage";
import { createFileRoute, Link } from "@tanstack/react-router";
import { AlertCircle } from "lucide-react";
import { useEffect } from "react";

export const Route = createFileRoute("/account-configuration-error")({
  component: () => <AccountConfigurationErrorScreen />,
});

function AccountConfigurationErrorScreen() {
  useEffect(() => {
    StorageUtility.removeAll();
  }, []);

  return (
    <div className="bg-background flex min-h-screen items-center justify-center p-4">
      <Card className="w-full max-w-lg rounded-[var(--radius-surface)] border-slate-200 shadow-lg shadow-slate-200/70">
        <CardHeader className="space-y-4 text-center">
          <div className="flex justify-center">
            <AlertCircle className="h-12 w-12 text-destructive" color="red" />
          </div>
          <h1 className="text-3xl font-semibold tracking-tight">
            Account configuration issue
          </h1>
        </CardHeader>
        <CardContent className="space-y-6 text-center">
          <p className="text-sm text-muted-foreground">
            We could not sign you in because of an account configuration issue.
            Please contact your account administrator or support.
          </p>
          <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
            <Button asChild>
              <Link to="/auth/signin">Try signing in again</Link>
            </Button>
            <Button asChild variant="outline">
              <a href="mailto:support@getvolume.com?subject=[Merchant Portal] Invalid account configuration">
                Contact support
              </a>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
